<template src="./Header.html"></template>

<script>
import Logo from 'svg/logo.svg';
import { isOpenedPopup } from 'src/mixins';

export default {

  mixins: [isOpenedPopup],

  components: {
    Logo,
  },

  data() {
    return {
      isMenuShow: false,
    };
  },

  methods: {
    clickMenu() {
      if (this.isMenuShow) {
        this.$refs.wrapper.scrollTop = 0;
      }
      this.isMenuShow = !this.isMenuShow;
      this.isOpenedPopup(this.isMenuShow);
    },
    clickLink() {
      this.isMenuShow = false;
      this.isOpenedPopup(false);
      this.$refs.wrapper.scrollTop = 0;
      window.scroll(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/vars.scss";
@import "~styles/logo_animations.scss";

.header{
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 97px;
  background-color: #fff;

  &.main{
    background-color: transparent;
    .header_logo, .header_phone{
      display: none;
    }

    .header_burger{
      opacity: 0;
      animation: fadeInDown 0.5s ease-out forwards;
      animation-delay: 1.4s;

      @media only screen and (max-width : $tablet){
        opacity: 1;
        animation: none;
      }
    }
  }

  @media only screen and (max-width : $phone){
    height: 17.96875vw;
  }
}

.header_logo{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 34px;
  height: 28px;
  cursor: pointer;

  &:hover{
    svg{
      fill: $blue;
    }
  }

  svg{
    fill: $dark-gray;
    transition: fill 0.35s;
  }

  @media only screen and (max-width : $tablet){
    display: none;
  }
}

.header_mask{
  height: 65px;
  margin-bottom: 45px;

  @media only screen and (max-width : $tablet){
    height: auto;
    margin-bottom: 0;
  }
}

.header_burger{
  width: 34px;
  position: absolute;
  left: 50%;
  top: 32px;
  height: 40px;
  transform: translateX(-50%);
  z-index: 12;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .icon{
    width: 24px;
    height: 24px;
    position: relative;
      &:before,
      &:after{
        content: '';
        position: absolute;
        width: 24px;
        height: 2px;
        background-color: currentColor;
          transition: transform 0.2s ease-out, top 0.2s ease-out 0.2s;
      }

      &:before {
        transform: rotate(0deg);
        top: 7px;
      }

      &:after {
        transform: rotate(0deg);
        top: 15px;
      }
  }


  &:hover{

    .header_menu-text{
       transform: translateY(7px);
       @media only screen and (max-width : $phone){
         transform: translateY(2.09375vw);
       }
    }
  }

  &.close{
    .icon{
        &:after, &:before{
          transition: transform 0.2s ease-out 0.2s, top 0.2s ease-out;
        }
        &:after{
          transform: rotate(45deg);
          top: 10px;
        }
        &:before{
          transform: rotate(-45deg);
          top: 10px;
        }
    }
  }

  @media only screen and (max-width : $phone){
    width: 9.375vw;
    top: 6.25vw;
  }
}

.header_menu{
  margin: 0 auto;
  display: block;
  cursor: pointer;
  width: 54px;
  position: relative;
  padding-top: 32px;
}

.header_menu-text{
  font-size: 14px;
  padding-top: 15px;
  letter-spacing: 6px;
  transition: transform 0.35s ease;

  @media only screen and (max-width : $phone){
    font-size: 3.75vw;
    padding-top: 2.125vw;
    letter-spacing: 1.40625vw;
  }
}

.header_phone{
  position: absolute;
  right: 0;
  top: 34px;
  font-size: 24px;
  font-family: $playfair-numbers;

  a{
    color: $dark-gray;
  }

  @media only screen and (max-width : $tablet){
    display: none;
  }
}

.header_popup{
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: $blue;
  z-index: 11;
}

.header_popup-items{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  @media only screen and (max-width : $tablet){
    position: relative;
    transform: translateX(-50%);
    top: 0;
    margin-top: 82px;
  }

  @media only screen and (max-width : $tablet){
    margin-top: 17.34375vw;
  }
}

.header_popup-wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
}

.header_popup-item-wrapper{
  display: block;
  margin-bottom: 45px;

  &.fade_item{
     opacity: 0;
  }
}

.header_popup-item{
  display: inline;
  color: $dark-gray;
  font-size: 48px;
  font-family: $playfair;
  letter-spacing: 2px;

  border-bottom: 1px solid transparent;
  transition: all 0.35s;

  &:hover{
    border-bottom: 1px solid $dark-gray;
  }

  @media only screen and (max-width : $tablet){
    margin-bottom: 32px;
    opacity: 1;
    letter-spacing: 2px;
    margin-bottom: 45px;
  }

  @media only screen and (max-width : $phone){
    font-size: 6.875vw;
    margin-bottom: 4.9vw;
  }
}

.header_popup-footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 123px;
  font-size: 12px;
  letter-spacing: 0.8px;

  @media only screen and (max-width : $phone){
    position: relative;
    height: auto;
    font-size: 2.8125vw;
    letter-spacing: 0.1875vw;

    .footer_redis, .footer_copy{
      top: 0;
    }
  }
}

.header_mobile{
  display: none;
  position: relative;
  color: $dark-gray;

  @media only screen and (max-width : $tablet){
    display: block;
    text-align: center;
    margin: 161px auto 0;
  }

  @media only screen and (max-width : $phone){
    margin-top: 26.25vw;
  }
}

.header_mobile-title{
  font-family: $playfair;
  font-size: 44px;
  line-height: 20px;
  letter-spacing: 12px;
  text-transform: uppercase;
  font-weight: 700;
  padding-bottom: 34px;

  @media only screen and (max-width : $phone){
    font-size: 9.375vw;
    letter-spacing: 2.5vw;
    line-height: 6.25vw;
    padding-bottom: 5.3125vw;
  }
}

.header_mobile-text{
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 4.3px;

  @media only screen and (max-width : $phone){
    font-size: 2.5vw;
    letter-spacing: 0.9375vw;
  }
}

.header_mobile-logo{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  width: 150px;
  top: -36px;
  height: 118px;

  svg{
    fill: #fff;
  }

  @media only screen and (max-width : $phone){
    width: 27.8125vw;
    top: -5.625vw;
    height: 22.65625vw;
  }
}

.header_phone-mobile{
  display: none;
  @media only screen and (max-width : $tablet){
    display: block;
    text-align: center;
    margin-top: 60px;
    cursor: pointer;
    a{
      font-size: 50px;
      font-family: $playfair;
      color: $dark-gray;
    }
  }

  @media only screen and (max-width : $phone){
    margin-top: 13vw;
    margin-bottom: 10vw;
    a{
      font-size: 8vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue